import {IBaseFetchOptions, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	SUBSCRIBE: {
		path: 'subscribe',
		method: 'POST'
	}
};

export interface ICreateNotifyMeOptions extends IBaseFetchOptions {
	body: {
		email: string
		productId: string
		languageCode?: string
		countryCode?: string
	}
}

export interface ICreateNotifyMeResponse extends IBaseResponse {
	message: string
}
